import { memo, type ReactNode, useMemo } from "react";
import * as React from "react";
import EditablePackageEntry from "./EditableEntry/EditablePackageEntry";
import ViewablePackageEntry from "../../CheckoutPage/ViewablePackageEntry";

export interface PackageEntryListProps {
  packEntryIds: number[];
  editMode?: boolean;
  onRender?: () => void;
}

export interface BasePackageEntryListProps {
  packEntryIds: number[];
  renderRow: (packEntryId: number, index: number) => ReactNode;
}

export const BasePackageEntryList = React.memo(({ packEntryIds, renderRow }: BasePackageEntryListProps) => (
  <div>{packEntryIds.map(renderRow)}</div>
));

export const CartPackageEntryList = memo(({ packEntryIds, editMode, onRender }: PackageEntryListProps) => {
  const renderRow: BasePackageEntryListProps["renderRow"] = useMemo(() => {
    if (editMode) {
      return (id: number, index: number) => (
        <EditablePackageEntry key={id} className={"mb-2"} index={index} packEntryId={id} onRender={onRender} />
      );
    } else {
      return (id: number, index: number) => (
        <div key={id} className={"pb-2"}>
          <ViewablePackageEntry packEntryId={id} index={index} />
        </div>
      );
    }
  }, [editMode, onRender]);

  return <BasePackageEntryList packEntryIds={packEntryIds} renderRow={renderRow} />;
});

export default CartPackageEntryList;
